// src/Sidebar.js
import React , {useState , useEffect} from "react";
import "./sidebarr.css";
import logo from "../../../utilities/gg-logo.png";
import MoreTimeIcon from '@mui/icons-material/MoreTime';

import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import CelebrationOutlinedIcon from "@mui/icons-material/CelebrationOutlined";
import AddReactionOutlinedIcon from "@mui/icons-material/AddReactionOutlined";
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CollectionsBookmarkOutlinedIcon from "@mui/icons-material/CollectionsBookmarkOutlined";
import TravelExploreOutlinedIcon from "@mui/icons-material/TravelExploreOutlined";


const Sidebar = (props) => {
  const user = props.user;
  const roleText = (user?.role || "Employee").toString();
  const displayName = (user?.name || "User").toString();
  const initials = displayName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("") || "U";
  const designationText = (props.Employee?.designation || roleText).toString();

  const myProfileClass = props.myProfileToggle ? "activeNav" : "deactivateNav";
  const myDashboardClass = props.timerShowToggle ? "activeNav" : "deactivateNav";
  const eventsClass = props.eventsToggle ? "activeNav" : "deactivateNav";
  const requestLeaveClass = props.requestLeaveToggle ? "activeNav" : "deactivateNav";
  const employeeCountdownClass = props.employeesCountdownToggle ? "activeNav" : "deactivateNav";
  const ideasClass = props.ideasToggle
  ? "activeNav"
  : "deactivateNav";
  const attendanceClass = props.attendanceToggle ? "activeNav" : "deactivateNav";
  const projectShowcaseClass = props.projectShowcaseToggle ? "activeNav" : "deactivateNav";
  const browseProjectsClass = props.browseProjectsToggle ? "activeNav" : "deactivateNav";
  const [Employee, setEmployee] = useState(null);


  useEffect(() => {//
    const loginEmployee = async () => {
      try {
        const response = await fetch(`https://hr-backend-72v1.onrender.com/loginemployee?email=${user.email}`);
        const data = await response.json();

        if (response.ok) {
          // console.log('Login successful:', data);
          setEmployee(data);
        } else {
          console.error('Login failed:', data.message);
        }
      } catch (error) {
        console.error('Error during login:', error);
      }
    };

    loginEmployee();
  }, [user.email]);


  return (
    <div className="sidebar-space">
      <div className="sidebar ggSidebar">
        <div className="side-content">
          <div className="ggSidebarTop">
            <div className="ggLogoRow">
              <div className="ggLogoBadge" aria-hidden="true">
                <img className="ggLogoImg" src={logo} alt="Growth Guild" />
              </div>
              <div className="ggBrandText">
                <div className="ggBrandTitle">GROWTH</div>
                <div className="ggBrandSub">GUILD HRMS</div>
              </div>
            </div>
            <div className="ggDivider" />

            <div className="ggRoleBadge">
              <span className="ggRoleText">{roleText}</span>
            </div>
          </div>
          <div className="buttons">
            {/* EMPTY */}
            <button
              className={`navButton ggNavItem ${myDashboardClass}`}
              onClick={props.onShowTimer}
            >
              <span className="ggNavLeft">
                <DashboardOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Dashboard</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${myProfileClass}`}
              onClick={props.onShowProfile}
            >
              <span className="ggNavLeft">
                <PersonOutlineIcon className="ggNavIcon" />
                <span className="ggNavLabel">My Profile</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${eventsClass}`}
              onClick={props.onShowEvents}
            >
              <span className="ggNavLeft">
                <CelebrationOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Upcoming Events</span>
              </span>
            </button>
            {/* https://hr-backend-72v1.onrender.com */}
            <button
              className={`navButton ggNavItem ${requestLeaveClass}`}
              onClick={props.onShowRequestLeave}
            >
              <span className="ggNavLeft">
                <AddReactionOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Request A Leave</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${ideasClass}`}
              onClick={props.onShowIdeas}
            >
              <span className="ggNavLeft">
                <TipsAndUpdatesIcon className="ggNavIcon" />
                <span className="ggNavLabel">Ideas Board</span>
              </span>
            </button>
            <button
              className={`navButton ggNavItem ${attendanceClass}`}
              onClick={props.onShowAttendance}
            >
              <span className="ggNavLeft">
                <CalendarMonthOutlinedIcon className="ggNavIcon" />
                <span className="ggNavLabel">Attendance</span>
              </span>
            </button>
            {Employee && Employee.manager == 'yes' &&
              <button
                className={`navButton ggNavItem ${employeeCountdownClass}`}
                onClick={props.onShowEmployeesCountdown}
              >
                <span className="ggNavLeft">
                  <MoreTimeIcon className="ggNavIcon" />
                  <span className="ggNavLabel">Actives Now</span>
                </span>
              </button>
            }
            {Employee &&
              <button
                className={`navButton ggNavItem ${projectShowcaseClass}`}
                onClick={props.onShowProjectShowcase}
              >
                <span className="ggNavLeft">
                  <CollectionsBookmarkOutlinedIcon className="ggNavIcon" />
                  <span className="ggNavLabel">Project Showcase</span>
                </span>
              </button>
            }
            {Employee && Employee.salesRep == 'yes' &&
              <button
                className={`navButton ggNavItem ${browseProjectsClass}`}
                onClick={props.onShowBrowseProjects}
              >
                <span className="ggNavLeft">
                  <TravelExploreOutlinedIcon className="ggNavIcon" />
                  <span className="ggNavLabel">Browse Projects</span>
                </span>
              </button>
            }

          </div>
        </div>

        <div className="ggSidebarBottom">
          <div className="ggDivider" />
          <div className="ggUserPanel">
            <div className="ggAvatar" aria-hidden="true">
              {initials}
            </div>
            <div className="ggUserText">
              <div className="ggUserName">{displayName}</div>
              <div className="ggUserRole">{designationText}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
